import React from "react"
import { withTheme } from "emotion-theming"

const Instagram = ({ theme, colour }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
    <path
      fill={colour || theme.colour}
      d="M6.99977 4.49121c-1.45833 0-2.56666 1.10833-2.56666 2.56667 0 1.4 1.16666 2.50833 2.56666 2.50833 1.4 0 2.50834-1.225 2.50834-2.56667 0-1.4-1.10834-2.50833-2.50834-2.50833z"
    />
    <path
      fill={colour || theme.colour}
      d="M13.183 2.97476c-.2333-1.225-1.1666-2.041664-2.3916-2.15833-.7-.058334-1.40003-.116667-2.15836-.116667-1.80833 0-3.61667-.058333-5.36667.116667C1.92471.933096.93304 1.92476.816374 3.2081c-.116667.64166-.116667 1.225-.116667 1.86666v4.025c0 .58334.058333 1.10834.116667 1.69164.058333.5834.291666 1.1084.699996 1.575.64167.6417 1.4.8167 2.21667.875 1.05.0584 2.15833.0584 3.20833.0584 1.28334 0 2.50834.0583 3.79163-.1167 1.225-.175 2.0417-.7583 2.3917-1.9833.175-.6417.175-1.28337.175-1.92504V4.6081c0-.525 0-1.10834-.1167-1.63334zM6.94137 11.0248c-2.21666 0-3.96666-1.80837-3.96666-4.08337 0-2.21667 1.86666-3.96667 4.08333-3.96667S11.0247 4.7831 11.0247 7.0581c0 2.15833-1.80833 4.025-4.08333 3.9667zm4.20003-7.23337c-.525 0-.9334-.40833-.9334-.93333 0-.525.4084-.99167.9917-.99167.4667 0 .9333.46667.9333.93333 0 .58334-.4666.99167-.9916.99167z"
    />
  </svg>
)

export default withTheme(Instagram)
